import React from 'react';

export const authRouteConfig = [
  {
    routes: [
      {
        path: '/signin',
        component: React.lazy(() => import('./Signin')),
      },
    ],
  },  
  {
    routes: [
      {
        path: '/login',
        component: React.lazy(() => import('./Login')),
      },
    ],
  },  
  {
    routes: [
      {
        path: '/forgot-password',
        component: React.lazy(() => import('./ForgotPassword')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/reset-password',
        component: React.lazy(() => import('./ResetPassword')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/verification',
        component: React.lazy(() => import('./SignupVerification')),
      },
    ],
  }, 
];
